import { Injectable } from '@angular/core';
import { EvidenceStatus } from '../../../models/chat.model';

/**
 * Fase 4: normaliza el `evidence_status` aditivo del backend al tipo de la UI. Defensivo y
 * retrocompatible: si el campo falta o no es un string no vacío, degrada a `undefined`.
 * Nunca lanza; nunca devuelve `any`.
 */
@Injectable({ providedIn: 'root' })
export class ChatGroundingMapperService {
  /** Normaliza `evidence_status` a un string no vacío; `undefined` si falta. */
  mapEvidenceStatus(raw: unknown): EvidenceStatus | undefined {
    if (typeof raw !== 'string') {
      return undefined;
    }
    const trimmed = raw.trim();
    return trimmed ? (trimmed as EvidenceStatus) : undefined;
  }
}
